import { apolloClient } from "@/plugins/vue-apollo.js";

const changeUnitStatus = async ( variables) => {
    let responseFromApi = await apolloClient.mutate({
        mutation: require("@/landlord/api/mutations/change_unit_status.graphql"),
        variables:variables ,
    }).catch((error) => {
        throw error;
    })
    return responseFromApi;

};

export { changeUnitStatus };
